"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var variables_1 = require("../../../style/variables");
var Text_1 = __importDefault(require("../../Text/Text"));
var style_1 = require("../../../style");
var apps_1 = __importDefault(require("../../../icons/apps"));
var styles = {
    container: react_1.css({
        display: 'flex',
        gap: "var(" + variables_1.Spacing.sp12 + ")",
        minWidth: 220,
        background: "var(" + variables_1.RootColor.White + ")",
        borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
        textDecoration: 'none',
        padding: style_1.pxToRem(6, 16) + " var(" + variables_1.Spacing.sp8 + ")",
        '.app-icon': {
            width: 40,
            height: 40,
            borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
            background: "var(" + variables_1.RootColor.Gray.DARK_4 + ")",
        },
        ':hover': {
            background: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
            cursor: 'pointer',
        },
    }),
    disabledContainer: react_1.css({
        '.app-icon': {
            background: "var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
        },
    }),
};
var AppListItem = function (_a) {
    var app = _a.app;
    return (react_1.jsx("a", { href: app.enabled ? app.appUrl : app.promoUrl, css: [
            styles.container,
            app.enabled ? undefined : styles.disabledContainer,
        ], target: "_blank", "data-6si-name": "app-switcher--app-list--item", "data-6si-id": app.type },
        react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", className: "app-icon" },
            react_1.jsx(apps_1.default, { app: app.type, theme: app.enabled ? 'dark' : 'light', size: 32 })),
        react_1.jsx(layout_1.Flex, { direction: "column", gap: "var(" + variables_1.Spacing.sp4 + ")", justifyContent: "center" },
            react_1.jsx(Text_1.default.Body, { weight: "semibold", color: "var(" + (app.enabled ? variables_1.TextColor.HEAD : variables_1.TextColor.DEFAULT) + ")" }, app.name),
            app.enabled ? null : (react_1.jsx(Text_1.default.Body, { size: "sm", color: "var(" + variables_1.TextColor.SECONDARY + ")" }, app.description)))));
};
exports.default = AppListItem;
